import { TableSorting } from "components"
import moment from "moment"
import { cellValueExcel, RowExportTypeExcel } from "types"
import { APPROVAL, excel } from "utils"
import { ReceivedType } from "../types"

export function ExportExcelReceived(props: {
    data: ReceivedType[],
    filter: {
        dateFrom: string | undefined,
        dateTo: string | undefined
    },
    module?: string,
    title: string,
    fileName: string
    activeColumns: TableSorting[]
}) {
    const activeCols = props.activeColumns.filter(col => col.isActive !== false)

    const columns = [
        { header: "NO", key: "no", width: 5 },
        ...activeCols
            .map(col => renderColumn(col.value as string))
            .filter((col): col is NonNullable<typeof col> => col !== undefined),
    ]

    const dataMap = props.data.map((item, index) => {
        const row: Record<string, any> = { no: index + 1 }

        activeCols.forEach(col => {
            const colMeta = renderColumn(col.value as string)
            if (colMeta) {
                row[colMeta.key] = renderCellValue(col.value as string, item)
            }
        })

        return row
    })

    excel({
        dataList: dataMap,
        column: columns,
        module: props.module,
        title: props.title,
        fileName: props.fileName,
        date: `${moment(props.filter.dateFrom).format('DD-MM-YYYY')} - ${moment(props.filter.dateTo).format('DD-MM-YYYY')}`
    })
}

function numberFormat(value: number): cellValueExcel {
    return {
        text: value,
        style: {
            alignment: {
                horizontal: "right"
            },
            numFmt: "#,##0"
        }
    }
}

function renderColumn(title: string): { header: string; key: string | number; width: number } | undefined {
    const map: Record<string, { header: string; key: keyof RowExportTypeExcel; width: number }> = {
        "trx_code": { header: "RECEIVED ID#", key: "trx_code", width: 20 },
        "transfer_code": { header: "REF. TRANSFER ID#", key: "transfer_code", width: 20 },
        "transaction_date": { header: "DATE", key: "transaction_date", width: 15 },
        "location_from": { header: "SOURCE LOCATION", key: "location_from", width: 30 },
        "qty_transfer": { header: "TRANSFERED", key: "qty_transfer", width: 20 },
        "location_to": { header: "DESTINATION LOCATION", key: "location_to", width: 30 },
        "qty_received": { header: "RECEIVED", key: "qty_received", width: 20 },
        "qty_rejected": { header: "REJECTED", key: "qty_rejected", width: 20 },
        "employee_name": { header: "TRAIDER", key: "employee_name", width: 20 },
        "approval_status": { header: "APPROVED", key: "approval_status", width: 15 },
        "memo": { header: "MEMO", key: "memo", width: 30 }
    }
    return map[title]
}

function renderCellValue(title: string, item: any): any {
    switch (title) {
        case "trx_code":
            return item.trx_code
        case "transfer_code":
            return item.transfer.trx_code
        case "transaction_date":
            return moment(item.transaction_date).format("DD/MM/YYYY")
        case "location_from":
            return item.location_from?.location_name
        case "qty_transfer":
            return numberFormat(item.qty_transfer)
        case "location_to":
            return item.location_to?.location_name
        case "qty_received":
            return numberFormat(item.qty_received)
        case "qty_rejected":
            return numberFormat(item.qty_rejected)
        case "employee_name":
            return item.employee.employee_name
        case "approval_status":
            return APPROVAL[item.approval_status]
        case "memo":
            return item.memo
        default:
            return undefined
    }
}